export default JSON.parse(localStorage.getItem('config')) || (window as any).CONFIG;
